const variables = {
  colors: {
    lightGray: '#999999'
  }
};

export { variables };
